import axios from "axios";
import { hasError, getErrors, setError } from "~/utils/service-error-handling";

function setDefaultError(response) {
  if (!getErrors(response.data) && response.status != 303)
    setError(response.data, response.status, response.statusText);
}

function showAndThrowError(response) {
  setDefaultError(response);
  throw response;
}

export default function () {
  axios.interceptors.response.use(
    function (response) {
      if (hasError(response)) showAndThrowError(response);

      return response;
    },
    function (error) {
      if (error.response) showAndThrowError(error.response);

      throw error;
    }
  );
}
